module.exports = __webpack_public_path__ + "img/pr-2.e2c751f7.png";